export default "__VITE_ASSET__CFLVBLe0__"